module.exports = __webpack_public_path__ + "img/304_26@2x.c55d2e2e.png";